// extracted by mini-css-extract-plugin
export default {"container":"notification_watcher_query-module__container--30FxV","new":"notification_watcher_query-module__new--s39Zc"};